class ReviveBanner {
    constructor(element) {
        this._container = element;
        this._banner = "";

        this.getData();
        this.clearData();
        this.init();
    }
    getData() {
        this._banner = this._container.dataset.banner;
    }
    clearData() {
        this._container.removeAttribute("data-banner");
    }
    init() {
        if(typeof this._banner != "undefined") {
            // createContextualFragment ejecuta los <script> inline, igual que jQuery.replaceWith
            const fragment = document.createRange().createContextualFragment(this._banner);
            this._container.replaceWith(fragment);
        }
    }
}

export default ReviveBanner
